import PropTypes from 'prop-types';
import styles from './FJVoiceCloningSetting.module.less';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton.jsx';
import { AI_VOICE_CLONE_USE_CREDIT } from '../../../redux/slices/FJSliceVoiceCloning.js';
import classNames from 'classnames';
import FJProfileList from './FJProfileList.jsx';
import FJInput from '../../../common/components/FJInput/FJInput.jsx';
import FJAudioPlay from '../../../common/components/audio/FJAudioPlay/FJAudioPlay.jsx';
import FJLanguageSelect from './FJLanguageSelect.jsx';
import FJBackArrowIcon from '../../../assets/svg/back-arrow.svg?react';
import FJTextToSpeechConfig from '../../../config/appConfig/FJTextToSpeechConfig.js';
import useDefaultFreeLimit from '../../../hooks/useDefaultFreeLimit.jsx';

const FJVoiceCloningSetting = props => {
    const {
        profileId,
        voiceName,
        selectedLang,
        audioUrl,
        onChangeVoiceName,
        onChangeProfile,
        onChangeLang,
        onGenerate,
        audioName,
        deleteAudio,

        taskStatus,
        isProjectLoading,
        creditNumber,
        freeNumCreation,
    } = props;

    const isFree = freeNumCreation > 0 && creditNumber < AI_VOICE_CLONE_USE_CREDIT;
    const defaultFreeNumCreation = useDefaultFreeLimit('fish-speech');

    return (
        <>
            <div className={styles.back} onClick={deleteAudio}>
                <FJBackArrowIcon />
                {FJLocalStore._('back')}
            </div>
            <div className={styles.title}>{FJLocalStore._('create-voice-clone')}</div>
            <div className={styles.content_box}>
                <div className={styles.sub_title}>{FJLocalStore._('profile')}</div>
                <FJProfileList value={profileId} onChange={onChangeProfile} />
                <div className={classNames(styles.sub_title, styles.is_require)}>{FJLocalStore._('name')}</div>
                <FJInput
                    placeholder={FJLocalStore._('please-enter-a-name')}
                    style={{ marginBottom: '20px' }}
                    onChange={onChangeVoiceName}
                    value={voiceName}
                    maxLength={FJTextToSpeechConfig.NAME_MAXLENGTH}
                />
                <div className={styles.sub_title}>{FJLocalStore._('choose-clone-language')}</div>
                <FJLanguageSelect style={{ marginBottom: '20px' }} value={selectedLang} onChange={onChangeLang} />
                <div className={styles.sub_title}>{FJLocalStore._('preview-voice')}</div>
                <FJAudioPlay audioUrl={audioUrl} audioName={audioName} deleteAudio={deleteAudio} />
            </div>
            <div className={styles.gen_btn}>
                <FJGenerateButton
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={AI_VOICE_CLONE_USE_CREDIT}
                    isProjectLoading={isProjectLoading}
                    style={{ marginTop: '24px' }}
                    isShowUsageDetail={false}
                    onClick={onGenerate}
                    isFreeBottom={true}
                    defaultFreeNumCreation={defaultFreeNumCreation}
                />
            </div>
        </>
    );
};

FJVoiceCloningSetting.propTypes = {
    profileId: PropTypes.string,
    voiceName: PropTypes.string,
    selectedLang: PropTypes.string,
    audioUrl: PropTypes.string,
    onChangeVoiceName: PropTypes.func,
    onChangeProfile: PropTypes.func,
    onChangeLang: PropTypes.func,
    onGenerate: PropTypes.func,
    audioName: PropTypes.string,
    deleteAudio: PropTypes.func,
    taskStatus: PropTypes.string,
    isProjectLoading: PropTypes.bool,
    creditNumber: PropTypes.number,
    freeNumCreation: PropTypes.number,
};
export default FJVoiceCloningSetting;
